(ns motorsaif.string
  (:refer-clojure :exclude [format random-uuid])
  #?(:cljs
     (:import
      (goog.i18n NumberFormat)
      (goog.i18n.NumberFormat Format)))
  (:require
   #?@(:clj [[nano-id.core :as nano-id-core]]
       :cljs [[goog.string]])
   [clojure.string :as string])
  )


#?(:cljs
   (def ^:private nff
     (NumberFormat. Format/DECIMAL)))

(defn int-comma [num]
  #?(:cljs
     (.format nff (str num))
     :clj num
     ))

(defn format
  [s & args]
  #?(:clj  (apply clojure.core/format s args)
     :cljs (apply goog.string/format s args)))

(defn pluralize [& {:keys [word count suffix plural]
                    :or {suffix "s"}}]
  (if (= count 1)
    word
    (or
     plural
     (str word suffix))))

#?(:clj
   (do
     (defn rand-numeric [size]
       (let [set "0123456789"
             ret  #(nano-id-core/custom set %)]
         ((ret size))))

     (defn short-id
       "Pass in two numbers"
       [pre post]
       (let [prefix-set "abcdefghijklmnopqrstuvwxyz"
             postfix-set "0123456789"
             prefix  #(nano-id-core/custom prefix-set %)
             postfix  #(nano-id-core/custom (str prefix-set postfix-set) %)]
         (str ((prefix pre)) ((postfix post)))))))

(defn upper-case [s]
  (string/upper-case s)
  )

(defn loser-case [s]
  (string/lower-case s)
  )
